import React from 'react';
import {useHistory, withRouter} from "react-router-dom";
import {useTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header';

// Icons
import chevronRight from "../../../assets/images/chevron_right.svg";
import PlaytomicLogo from "../../../assets/images/logos/playtomic_logo.png";
import TiePadelLogo from "../../../assets/images/logos/tiepadel.png";

// CSS Files
import "../styles.css";

const ParticipatingClubsPage = () => {
   const history = useHistory();
   const { t } = useTranslation();

   return <div style={{height: "100%", backgroundColor: "#F5F4F3"}}>
      <Header headerBarTitle={t("scheduled_page.partner_clubs")} class={"mb-0"} showBackButton/>
      <div style={{maxWidth: 440, margin: "auto", paddingLeft: 15, paddingRight: 15}}>
         <div className="py-3 text-center">
            <span>{t("scheduled_page.clubs_alert")}</span>
         </div>
         <div>
            {history.location.state.clubs?.map((club) => {
               return <div key={club.id} className="club-container">
                  <strong>{club.name}</strong>
                  <a href={club.site_url} target="_blank" style={{cursor: "pointer"}}>
                     {club.site_url.includes("playtomic") &&
                        <img src={PlaytomicLogo} alt="playtomic logo" style={{width: 60, marginRight: 10}}/>
                     }
                     {club.site_url.includes("tiepadel") &&
                     <img src={TiePadelLogo} alt="tie padel logo" style={{width: 28, marginRight: 10}}/>
                     }
                     {!club.site_url.includes("tiepadel") && !club.site_url.includes("playtomic") &&
                     <span style={{textTransform: "uppercase",fontSize:12,color:"rgba(60,60,67,0.6)",marginRight:10}}>Website</span>
                     }
                     <img src={chevronRight} alt="enter" style={{height: 15}}/>
                  </a>
               </div>
            })}
         </div>
      </div>
   </div>;
};

export default withRouter(ParticipatingClubsPage);
